/** biome-ignore-all lint/complexity/noStaticOnlyClass: <explanation> */

import { context } from "@core-ts/Contexts/Context"

export class FeatureFlags {
    private static getUrlParams(): URLSearchParams {
        if (typeof window === "undefined") {
            return new URLSearchParams()
        }
        return new URLSearchParams(window.location.search)
    }

    private static getFullUrl(): string {
        if (typeof window === "undefined") {
            return ""
        }
        return window.location.href
    }

    static hasFlag(paramName: string, expectedValue?: string): boolean {
        const params = this.getUrlParams()
        const fullUrl = this.getFullUrl()
        const paramValue = params.get(paramName)

        if (expectedValue !== undefined) {
            return paramValue === expectedValue || fullUrl.includes(`${paramName}=${expectedValue}`)
        }

        return paramValue !== null || fullUrl.includes(paramName)
    }

    //search bar
    static isSearchEnabled(): boolean {
        if (
            context.instance.instanceName === "aecrm" ||
            context.instance.instanceName === "dccrm" ||
            context.instance.instanceName === "eccrm"
        ) {
            return true
        }

        return this.hasFlag("enable-search", "1")
    }
    //site wide message
    static isSiteMessageVisible(): boolean {
        return this.hasFlag("enable-site-message", "1")
    }
    //Dark mode
    static isDarkModeEnabled(): boolean {
        return this.hasFlag("enable-mode", "dark")
    }
    //Permission icon - Always visible by default
    static isPermissionsVisible(): boolean {
        return true
        // return this.hasFlag("permission-visible")
    }
    //Permission & 2FA
    static isUserSettingsVisible(): boolean {
        return this.hasFlag("user-settings", "visible")
    }
    // This isn't really a feature flag, but it's convenient to put it here
    // It allows us to show admin settings in the frontend even from non-admin users
    // This is useful for debugging permission issues
    static showAdminSettings(): boolean {
        return this.hasFlag("admin", "1")
    }

    // Show the full header with all menu items in ecstore
    static showNewHeader(): boolean {
        return this.hasFlag("new-header", "1")
    }

    static showAddZone(): boolean {
        return this.hasFlag("add-zone-device", "1")
    }

    static isCustomUserViewEnabled(): boolean {
        return this.hasFlag("custom-user-view", "1")
    }

    static getValue(paramName: string): string | null {
        return this.getUrlParams().get(paramName)
    }

    //impersonation in userbadge
    static isImpersonationEnabled(): boolean {
        if (typeof window === "undefined") return false
        const params = new URLSearchParams(window.location.search)
        return params.has("enable-impersonation")
    }
    static showEditViews(): boolean {
        return window.location.search.includes("editViews=on")
    }

    static showSensorStatus(): boolean {
        return FeatureFlags.hasFlag("enable-sensor-status", "1")
    }

    static showTreeDevices(): boolean {
        return FeatureFlags.hasFlag("show-tree-devices", "1")
    }
}
